export default "__VITE_ASSET__BC$RU9ZK__"